import { makeStyles } from '@material-ui/core/styles';
import { buttonAddStyles, buttonPrimaryStyles, buttonDeleteStyles } from 'shared/Buttons/button.styles';

export const useListQRCodesStyles = makeStyles(theme => ({
  qrCodes: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  title: {
    margin: '2rem 0 1.5rem 0'
  },
  buttonAdd: {
    ...buttonAddStyles
  },
  buttonBack: {
    ...buttonPrimaryStyles
  },
  buttonDelete: {
    ...buttonDeleteStyles
  }
}));
